import { Dropdown, Layout, theme, Badge, Popover, Spin, Tooltip } from "antd";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import './topHeader.css';
import { logout } from '../../../modules/userManagement/auth/authSlice'
import { useDispatch, useSelector } from 'react-redux';
import { checkPermissions, pusherInitializer, decryptLocalData } from "@comps/commonFunctions"
import {
  FileTextOutlined,
  GiftOutlined,
  LogoutOutlined,
  MenuOutlined,
  MoonOutlined,
  NotificationOutlined,
  SearchOutlined,
  SunOutlined,
  UserOutlined,
  DownOutlined
} from '@ant-design/icons';
import { buildNavigationTree, flattenNavigationPages, normalizeNavKey } from '../navigation/navigationTree';

import { makeRequest } from '@utils/helpers';
import { countTopNotificationsReq } from "./requests";
import { notify } from '@utils/helpers';
import TopNotification from './TopNotification';
import { ShowErrorModal } from "../../../wrappers/components";
import { getJobResultErrors } from "../../../modules/common/requests";
import { getResourceDataReq, createSelectList } from "@comps/commonFunctions";
import _ from "lodash";
import JobProgressPopup from "../../../wrappers/layout/JobProgressPopup";
import { useKlokTheme } from "../../../theme/KlokThemeProvider";

const { Header } = Layout;

const RECENT_PAGES_KEY = 'commandSearchRecentPages';
const MAX_PAGE_RESULTS = 8;

const normalizeSearchText = (value) => String(value || '').toLowerCase().trim();

// Rank exact/prefix matches above mid-string matches so the best hit is preselected.
const scorePageMatch = (page, query) => {
  const label = normalizeSearchText(page.label);
  const breadcrumb = normalizeSearchText(page.breadcrumb);

  if (label === query) return 0;
  if (label.startsWith(query)) return 1;
  if (label.includes(query)) return 2;
  if (breadcrumb.includes(query)) return 3;
  return 4;
};

const readRecentPages = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(RECENT_PAGES_KEY));
    return Array.isArray(raw) ? raw : [];
  } catch {
    return [];
  }
};

const getFirstText = (...values) => {
  const found = values.find((value) => value !== undefined && value !== null && String(value).trim() !== '');
  return found === undefined ? '' : String(found);
};

const getUserInitials = (user = {}) => {
  const name = getFirstText(user.full_name, user.name, user.email, user.code);
  const parts = name.split(/\s+/).filter(Boolean);

  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }

  return name.slice(0, 2).toUpperCase() || 'U';
};

const getProfileImageUrl = (url) => {
  const normalizedUrl = getFirstText(url);
  const placeholderImages = ['images/arnold-avatar.jpg', '/images/arnold-avatar.jpg'];

  if (!normalizedUrl || placeholderImages.includes(normalizedUrl)) {
    return '';
  }

  return normalizedUrl;
};

const TopHeader = ({ navigation = null, isMobileViewport = false, mobileNavOpen = false, onToggleNavigation }) => {
  const [searchLoader, setSearchLoader] = useState(false);
  const [, setBackgroundLoader] = useState(false);
  const authUser = useSelector((state) => state.auth.authUser);
  const authPermissions = useSelector((state) => state.auth.permissions);
  const [employeesAll, setAllEmployees] = useState([]);
  const [childComponent, setChildComponent] = useState(null)
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [notifyCount, setNotifyCount] = useState(null)
  const [empployments, setEmployments] = useState([]);
  const [profileMenuOpen, setProfileMenuOpen] = useState(false);
  const [commandOpen, setCommandOpen] = useState(false);
  const [commandQuery, setCommandQuery] = useState('');
  const [profileImageFailed, setProfileImageFailed] = useState(false);
  const [commandActiveIndex, setCommandActiveIndex] = useState(0);
  const { themeMode, toggleThemeMode } = useKlokTheme();
  const commandInputRef = useRef(null);
  const commandActiveItemRef = useRef(null);

  // Every page the current user can reach (permission-filtered, incl. nested children),
  // derived from the live sidebar navigation state with cached storage as a fallback.
  const pageIndex = useMemo(() => {
    const nav = navigation?.permissions ? navigation : decryptLocalData('navigation');
    if (!nav?.permissions?.length) return [];

    const actionPermissions = authPermissions && Object.keys(authPermissions).length
      ? authPermissions
      : decryptLocalData('permissions') || {};

    return flattenNavigationPages(
      buildNavigationTree(nav.permissions, nav.custom_pay_items),
      nav.permissions,
      actionPermissions
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser, authPermissions, navigation]);

  // What's New moved out of the sidebar into the header, but stays permission-gated
  // exactly as the sidebar entry was.
  const canSeeWhatsNew = useMemo(() => {
    const nav = navigation?.permissions ? navigation : decryptLocalData('navigation');
    return Boolean(nav?.permissions?.some(
      (item) => normalizeNavKey(item?.module_key || item?.name) === 'whatsnew'
    ));
  }, [navigation]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const profileImageUrl = getProfileImageUrl(authUser.profile_pic_url);
  const profileInitials = getUserInitials(authUser);

  useEffect(() => {
    setProfileImageFailed(false);
  }, [profileImageUrl]);

  useEffect(() => {
    countNotify();

  }, [])

  //end report
  const handleLogout = () => {
    dispatch(logout())
    window.location.replace('/');
  }

  useEffect(() => {
    const user = decryptLocalData('user');
    if (!user || !user.tenant) {
      return;
    }
    const pusher = pusherInitializer();
    const channel = pusher.subscribe(user.tenant);
    channel.bind('bell-notification-event', function (data) {
      if (data.data) {
        const decode = JSON.parse(data.data)
        if (decode.employment_id && decode.employment_id === user.employment_id) {
          notify(decode.message)
          countNotify()
        }
        else {
          countNotify()
        }
      }

    });
    // Cleanup function for unsubscribing and unbinding when the component is unmounted
    return () => {
      // Unbind the event handler
      channel.unbind('bell-notification-event');
      // Unsubscribe from the channel
      pusher.unsubscribe(user.tenant);
      // Disconnect from Pusher
      pusher.disconnect();
    };
    // eslint-disable-next-line
  }, [authUser]);

  //==========================Start Pusher=================================
  useEffect(() => {
    const user = decryptLocalData('user');
    if (!user || !user.tenant) {
      return;
    }
    const pusher = pusherInitializer();
    const channel = pusher.subscribe(user.tenant);
    channel.bind('shifts-created-event', function (res) {
      if (res.data.success) {
        //notify('Employees Shifts Created Successfully!')
      }
      else {
        if (res.employment_id === user.employment_id) {
          makeRequest(setBackgroundLoader, getJobResultErrors, res.data.id, onSuccessErrors, null);
        }

      }
    });
    // Cleanup function for unsubscribing and unbinding when the component is unmounted
    return () => {
      // Unbind the event handler
      channel.unbind('shifts-created-event');
      // Unsubscribe from the channel
      pusher.unsubscribe(user.tenant);
      // Disconnect from Pusher
      pusher.disconnect();
    };
    // eslint-disable-next-line
  }, [authUser]);

  const onSuccessErrors = (res) => {
    const errors = JSON.parse(res.errors)
    setChildComponent(<ShowErrorModal errors={ errors } module={ "Create Roster" } onCompleted={ () => setChildComponent(null) } />)
  }
  //==========================end Pusher =================================


  //on select employee after search
  const onView = (id, isAuth) => {
    if (id) {
      navigate(isAuth === true ? '/my-profile' : `/employees/profile/${id}`, {
        state: { from: window.location.pathname },
      });
    }
  };
  const onCompleted = (data) => {

    if (!data) {
      setNotificationOpen(false)
      setChildComponent(null)
      setCommandQuery('');
    }
  }
  //===================notification start=======================================
  const onNotificationOpenChange = (open) => {
    setNotificationOpen(open);

    if (open) {
      countNotify();
    }
  }

  const countNotify = () => {
    makeRequest(setBackgroundLoader, countTopNotificationsReq, null, onSuccessView, onError);
  }
  const onSuccessView = (res) => {
    setNotifyCount(res.count)
  }
  const onError = (res, err) => {
  }

  const handleProfileView = () => {
    setProfileMenuOpen(false);
    onView(authUser.employment_id, true);
  };

  const profileMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: 'View Profile',
      onClick: handleProfileView,
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      danger: true,
      onClick: handleLogout,
    },
  ];

  const debouncedGetEmployees = useCallback(
    _.debounce((value) => {
      getEmployees(`search_|${value}`);
    }, 500),
    [] // Empty array ensures the function is created only once
  );
  const onSearchEmployee = (value) => {
    debouncedGetEmployees(value)
    //getEmployees(`search_|${value}`)
  }
  const getEmployees = (filters) => {
    if (authUser.role_id === 1 || authUser.role_id === 4) {

    } else {
      filters = `${filters};subordinate_|${authUser.employment_id}`;
    }
    let payload = {
      page: 1,
      type: 'employment',
      filters: filters
    }
    makeRequest(setSearchLoader, getResourceDataReq, payload, onSuccess, onError);
  }

  const onSuccess = (response) => {
    setAllEmployees(response.resources.data)
    setEmployments(createSelectList(response.resources.data));
    setSearchLoader(false)
  }

  const onFocusEmployeeSearch = () => {
    if (empployments.length === 0) {
      getEmployees('search_|')
    }
  }

  // const handleSupportChat = () => {
  //   setChildComponent(<Assistant />);
  // }

  const commandPeople = useMemo(() => {
    const source = employeesAll.length > 0
      ? employeesAll.map((employee) => {
        const label = getFirstText(
          employee.full_name,
          employee.name,
          employee.employee_name,
          employee.full_name_code,
          employee.label
        );
        const designation = getFirstText(
          employee.designation_name,
          employee.designation?.name,
          employee.designation,
          employee.job_title_name,
          employee.job_title?.name
        );
        const code = getFirstText(employee.code, employee.employee_code, employee.employment_code);

        return {
          key: employee.id,
          id: employee.id,
          label: label || code || 'Employee',
          sub: [designation, code].filter(Boolean).join(' · '),
        };
      })
      : empployments.map((employee) => ({
        key: employee.value,
        id: employee.value,
        label: getFirstText(employee.label, employee.name, employee.title) || 'Employee',
        sub: getFirstText(employee.code, employee.description),
      }));

    return source.filter((employee) => employee.id);
  }, [employeesAll, empployments]);

  const filteredCommandPages = useMemo(() => {
    const query = normalizeSearchText(commandQuery);

    if (!query) {
      // Surface recently opened pages first when there is nothing to match against.
      const recentPaths = readRecentPages();
      const byPath = new Map(pageIndex.map((page) => [page.path, page]));
      const recent = recentPaths.map((path) => byPath.get(path)).filter(Boolean);
      const rest = pageIndex.filter((page) => !recentPaths.includes(page.path));

      return [...recent, ...rest].slice(0, MAX_PAGE_RESULTS);
    }

    return pageIndex
      .map((page) => ({ page, score: scorePageMatch(page, query) }))
      .filter(({ score }) => score < 4)
      .sort((a, b) => a.score - b.score)
      .slice(0, MAX_PAGE_RESULTS)
      .map(({ page }) => page);
  }, [commandQuery, pageIndex]);

  const filteredCommandPeople = useMemo(() => {
    const query = normalizeSearchText(commandQuery);
    const people = query
      ? commandPeople.filter((person) =>
        normalizeSearchText(`${person.label} ${person.sub}`).includes(query)
      )
      : commandPeople;

    return people.slice(0, 8);
  }, [commandPeople, commandQuery]);

  // Flat, ordered list of everything selectable (pages then people) so the keyboard
  // can move through both sections with a single active index.
  const commandResults = useMemo(() => ([
    ...filteredCommandPages.map((page) => ({ type: 'page', id: `page:${page.path}`, page })),
    ...filteredCommandPeople.map((person) => ({ type: 'person', id: `person:${person.id}`, person })),
  ]), [filteredCommandPages, filteredCommandPeople]);

  const openCommandSearch = useCallback(() => {
    setCommandOpen(true);
    onFocusEmployeeSearch();
  }, [onFocusEmployeeSearch]);

  const closeCommandSearch = useCallback(() => {
    setCommandOpen(false);
    setCommandQuery('');
  }, []);

  const handleCommandSearchChange = (event) => {
    const value = event.target.value;
    setCommandQuery(value);
    setCommandActiveIndex(0);
    onSearchEmployee(value);
  };

  const handleCommandPageOpen = (path) => {
    closeCommandSearch();
    if (!path) return;

    const recent = [path, ...readRecentPages().filter((item) => item !== path)].slice(0, 6);
    try {
      localStorage.setItem(RECENT_PAGES_KEY, JSON.stringify(recent));
    } catch {
      // ignore storage failures — recents are best-effort
    }

    navigate(path);
  };

  const handleCommandPersonOpen = (id) => {
    closeCommandSearch();
    onView(id);
  };

  const openCommandResult = (result) => {
    if (!result) return;
    if (result.type === 'page') handleCommandPageOpen(result.page.path);
    else handleCommandPersonOpen(result.person.id);
  };

  const handleCommandKeyDown = (event) => {
    if (!commandResults.length) return;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      setCommandActiveIndex((index) => (index + 1) % commandResults.length);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      setCommandActiveIndex((index) => (index - 1 + commandResults.length) % commandResults.length);
    } else if (event.key === 'Enter') {
      event.preventDefault();
      openCommandResult(commandResults[commandActiveIndex]);
    }
  };

  useEffect(() => {
    const handleCommandShortcut = (event) => {
      const isCommandSearch = (event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'k';

      if (isCommandSearch) {
        event.preventDefault();
        openCommandSearch();
        return;
      }

      if (event.key === 'Escape' && commandOpen) {
        event.preventDefault();
        closeCommandSearch();
      }
    };

    window.addEventListener('keydown', handleCommandShortcut);

    return () => {
      window.removeEventListener('keydown', handleCommandShortcut);
    };
  }, [closeCommandSearch, commandOpen, openCommandSearch]);

  useEffect(() => {
    if (commandOpen) {
      setCommandActiveIndex(0);
      window.setTimeout(() => commandInputRef.current?.focus(), 0);
    }
  }, [commandOpen]);

  // Keep the highlight valid as results shrink/grow, and scroll it into view.
  useEffect(() => {
    setCommandActiveIndex((index) => {
      if (index < commandResults.length) return index;
      return commandResults.length ? commandResults.length - 1 : 0;
    });
  }, [commandResults.length]);

  useEffect(() => {
    commandActiveItemRef.current?.scrollIntoView({ block: 'nearest' });
  }, [commandActiveIndex]);
  //==================notification ends=========================================
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  return (
    <>
      <Header className="top-header-layout" style={ { background: colorBgContainer } }>
        <div className="top-header-main">
          { childComponent }

          { isMobileViewport ? (
            <button
              type="button"
              className={ `top-nav-toggle${mobileNavOpen ? ' top-nav-toggle--active' : ''}` }
              onClick={ onToggleNavigation }
              aria-label={ mobileNavOpen ? 'Close navigation menu' : 'Open navigation menu' }
              aria-expanded={ mobileNavOpen }
              title={ mobileNavOpen ? 'Close menu' : 'Open menu' }
            >
              <MenuOutlined />
            </button>
          ) : null }

          { checkPermissions('dashboard', 'employmentSearch') ?
            <div className="top-search-container">
              <button
                type="button"
                className="top-command-search"
                onClick={ openCommandSearch }
                aria-label="Search pages, people, and actions"
                title="Search pages, people, and actions (Ctrl+K)"
              >
                <SearchOutlined className="top-command-search__icon" />
                <span className="top-command-search__text">Search anything — people, payslips, requests...</span>
                <kbd>Ctrl+K</kbd>
              </button>
            </div>
            : null
          }
        </div>

        {/* Right Side: Notifications & User Profile */ }
        <div className="header-right-actions">

          { canSeeWhatsNew ? (
            <Tooltip title="What's New" placement="bottom">
              <button
                type="button"
                className="notification-icon-btn whats-new-btn"
                onClick={ () => navigate('/whats-new') }
                aria-label="What's New"
              >
                <GiftOutlined />
              </button>
            </Tooltip>
          ) : null }
          <div className="notification-wrapper">
            <JobProgressPopup />
          </div>



          {/* <button
            type="button"
            className="theme-toggle-btn"
            onClick={ toggleThemeMode }
            aria-label={ themeMode === 'dark' ? 'Switch to light theme' : 'Switch to dark theme' }
            title={ themeMode === 'dark' ? 'Switch to light theme' : 'Switch to dark theme' }
          >
            { themeMode === 'dark' ? <SunOutlined /> : <MoonOutlined /> }
          </button> */}

          <div className="notification-wrapper">
            <Popover
              content={ <TopNotification onCompleted={ onCompleted } /> }
              trigger="click"
              placement="bottomRight"
              overlayClassName="top-notification-popover"
              open={ notificationOpen }
              onOpenChange={ onNotificationOpenChange }
              destroyTooltipOnHide
            >
              <Tooltip title="Notifications" placement="bottom" open={ notificationOpen ? false : undefined }>
                <Badge size="small" count={ notifyCount } color="var(--brand)" offset={ [2, 2] }>
                  <div className="notification-icon-btn" aria-label="Notifications">
                    <NotificationOutlined />
                  </div>
                </Badge>
              </Tooltip>
            </Popover>
          </div>

          <Dropdown
            menu={ { items: profileMenuItems } }
            trigger={ ['click'] }
            placement="bottomRight"
            open={ profileMenuOpen }
            onOpenChange={ setProfileMenuOpen }
            overlayClassName="profile-dropdown-menu"
          >
            <div
              className="user-profile-btn"
              title="Account menu"
            >
              <div className="user-profile-copy">
                <span className="user-profile-name">{ authUser.full_name + '-' + authUser.code }</span>
                {/* <span className="user-profile-name">{ authUser.email }</span> */ }
                <span className="user-profile-role">{ authUser.role_name || '' }</span>
              </div>
              { profileImageUrl && !profileImageFailed ? (
                <img
                  className="user-profile-avatar"
                  width={ 40 }
                  height={ 40 }
                  src={ profileImageUrl }
                  alt={ authUser.full_name || 'User' }
                  onError={ () => setProfileImageFailed(true) }
                />
              ) : (
                <span className="user-profile-avatar user-profile-avatar--initials" aria-label={ authUser.full_name || 'User' }>
                  { profileInitials }
                </span>
              ) }
              <DownOutlined
                className={ `user-profile-caret${profileMenuOpen ? ' user-profile-caret--open' : ''}` }
              />
            </div>
          </Dropdown>

        </div>
      </Header>

      { commandOpen ? (
        <div className="command-search-overlay show" onMouseDown={ closeCommandSearch }>
          <div
            className="command-search-box"
            role="dialog"
            aria-modal="true"
            aria-label="Search"
            onMouseDown={ (event) => event.stopPropagation() }
          >
            <div className="command-search-inputwrap">
              <SearchOutlined className="command-search-input-icon" />
              <input
                ref={ commandInputRef }
                className="command-search-input"
                placeholder="Search pages, people, actions..."
                autoComplete="off"
                role="combobox"
                aria-expanded="true"
                aria-controls="command-search-results"
                aria-activedescendant={ commandResults[commandActiveIndex]?.id }
                value={ commandQuery }
                onChange={ handleCommandSearchChange }
                onKeyDown={ handleCommandKeyDown }
              />
              <kbd>Esc</kbd>
            </div>

            <div className="command-search-list" id="command-search-results" role="listbox">
              <div className="command-search-cat">
                { commandQuery ? 'Pages' : 'Recent & pages' }
              </div>
              { filteredCommandPages.length > 0 ? filteredCommandPages.map((page, pageIdx) => {
                const isActive = commandActiveIndex === pageIdx;
                return (
                  <button
                    type="button"
                    key={ page.key }
                    id={ `page:${page.path}` }
                    ref={ isActive ? commandActiveItemRef : null }
                    role="option"
                    aria-selected={ isActive }
                    className={ `command-search-item${isActive ? ' is-active' : ''}` }
                    onMouseMove={ () => setCommandActiveIndex(pageIdx) }
                    onClick={ () => handleCommandPageOpen(page.path) }
                  >
                    <span className="command-search-item-icon"><FileTextOutlined /></span>
                    <span className="command-search-item-label">{ page.label }</span>
                    { page.breadcrumb ? <span className="command-search-sub">{ page.breadcrumb }</span> : null }
                  </button>
                );
              }) : (
                <div className="command-search-empty">No pages found</div>
              ) }

              <div className="command-search-cat">People</div>
              { searchLoader ? (
                <div className="command-search-loading">
                  <Spin size="small" />
                </div>
              ) : filteredCommandPeople.length > 0 ? filteredCommandPeople.map((person, personIdx) => {
                const globalIndex = filteredCommandPages.length + personIdx;
                const isActive = commandActiveIndex === globalIndex;
                return (
                  <button
                    type="button"
                    key={ person.key }
                    id={ `person:${person.id}` }
                    ref={ isActive ? commandActiveItemRef : null }
                    role="option"
                    aria-selected={ isActive }
                    className={ `command-search-item${isActive ? ' is-active' : ''}` }
                    onMouseMove={ () => setCommandActiveIndex(globalIndex) }
                    onClick={ () => handleCommandPersonOpen(person.id) }
                  >
                    <span className="command-search-item-icon"><UserOutlined /></span>
                    <span className="command-search-item-label">{ person.label }</span>
                    { person.sub ? <span className="command-search-sub">{ person.sub }</span> : null }
                  </button>
                );
              }) : (
                <div className="command-search-empty">No people found</div>
              ) }
            </div>

            <div className="command-search-foot">
              <span><kbd>Enter</kbd> open</span>
              <span><kbd>Esc</kbd> close</span>
            </div>
          </div>
        </div>
      ) : null }
    </>
  )
}

export default TopHeader;
